import { Outlet, lazyRouteComponent } from 'src/lib/routing';

import type { RouteObject } from 'src/lib/routing';

const AskablePlusConfirmation = lazyRouteComponent(() => import('components/askablePlus/confirmationScreen'));
const CreateAskablePlus = lazyRouteComponent(() => import('components/askablePlus/createAskablePlus'));
const ResearcherProjectOffer = lazyRouteComponent(() => import('components/researcher/projectOffer/projectOffer'));

export const askablePlusRoutes: RouteObject[] = [
  {
    path: 'askable-plus',
    element: <Outlet />,
    children: [
      {
        path: ':screen',
        element: <CreateAskablePlus />,
      },
      {
        path: ':projectID',
        children: [
          {
            path: 'researcher-offer',
            element: <ResearcherProjectOffer />,
          },
          {
            path: 'confirmation',
            element: <AskablePlusConfirmation />,
          },
          {
            path: ':screen/:subScreen',
            element: <CreateAskablePlus />,
          },
        ],
      },
    ],
  },
];
